import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "@/store";

Vue.config.productionTip = false

Vue.prototype.$store = store
Vue.prototype.$eventBus = new Vue();

window.ctx = store

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format"
momentDurationFormatSetup(moment);

window.VUE_APP = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
